<template>
  <a-card>
    <a-tabs :default-active-key="defaultActiveKey" @change="tbsChange">
      <a-tab-pane key="next" tab="通过">
        <a-alert class="workflow-alert-info" type="info" show-icon>
          <span slot="message">{{ `审批通过将流转至「${options[nextForm.to_step]}」; ${reviewUser}` }}</span>
        </a-alert>
        <a-form-model ref="nextForm" :model="nextForm" :rules="rules" :label-col="{ span: 2 }" :wrapper-col="{ offset: 2 }" class="small-form-model">
          <a-form-model-item label="备注信息" prop="comment">
            <vditor-editor v-model="nextForm.comment" :height="200" :width="960" />
          </a-form-model-item>
          <a-form-model-item>
            <a-space>
              <a-button class="submit-button" type="primary" :loading="loading.next" @click="onSubmit('next')"> 提交 </a-button>
            </a-space>
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane>
      <a-tab-pane key="back" tab="不通过">
        <a-alert class="workflow-alert-info" type="info" show-icon>
          <span slot="message">{{ `审批不通过将流转至「${options[backForm.to_step]}」; ${reviewUser}` }}</span>
        </a-alert>
        <a-form-model ref="backForm" :model="backForm" :rules="rules" class="small-form-model" :label-col="{ span: 2 }" :wrapper-col="{ offset: 2 }">
          <a-form-model-item label="备注信息" prop="comment">
            <vditor-editor v-model="backForm.comment" :height="200" :width="960" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="submit-button" type="primary" :loading="loading.back" @click="onSubmit('back')"> 提交 </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane>
      <a-tab-pane key="comment" tab="评论">
        <a-form-model ref="commentForm" :model="commentForm" :rules="rules" class="small-form-model" :label-col="{ span: 2 }" :wrapper-col="{ offset: 2 }">
          <a-form-model-item label="评论内容" prop="comment">
            <vditor-editor v-model="commentForm.comment" :height="200" :width="960" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="submit-button" type="primary" :loading="loading.comment" @click="onSubmit('comment')"> 提交 </a-button>
          </a-form-model-item>
        </a-form-model>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>
<script>
import { workflowMove, workflowComment } from '@/api/project/workflow';
import VditorEditor from '@/components/VditorEditor';

export default {
  components: {
    VditorEditor
  },
  props: {
    currentStep: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      packageList: [],
      height: 220,
      loading: {
        next: false,
        back: false,
        comment: false
      },
      options: {},
      defaultActiveKey: 'next',
      projectId: parseInt(this.$route.params.project_id) || null,
      nextForm: {
        team_id: null,
        release_ids: null
      },
      backForm: {
        release_ids: null,
        operation_type: 'back'
      },
      commentForm: {
        operation_type: 'comment',
        to_step: null,
        comment: ''
      },
      rules: {
        to_step: [{ required: true, message: '流转步骤不能为空', trigger: 'blur' }],
        comment: [{ required: true, message: '备注信息不能为空', trigger: 'blur' }]
      }
    };
  },
  computed: {
    reviewUser() {
      // const currentReview = this.currentStep.reviews.filter(item => item.result === 'processing');
      // const reviewGroup = {};
      // currentReview.forEach(item => {
      //   if (!reviewGroup[item.description]) {
      //     reviewGroup[item.description] = [];
      //   }
      //   reviewGroup[item.description].push(item.reviewer.nickname);
      // });
      // let item = '';
      // for (const key in reviewGroup) {
      //   if (key === '配置确认') {
      //     item += '配置确认中, 如有疑问可联系运维同学: 李济恺、殷毅、江韬、邹凯; ';
      //   } else {
      //     item += `${key}: ${reviewGroup[key].join('、')}; `;
      //   }
      // }
      // return item;
      return 'review的人';
    }
  },
  watch: {},

  mounted() {},
  methods: {
    tbsChange(activeKey) {
      // if (activeKey === 'next') {
      //   this.nextForm.release_ids = release_ids;
      // } else if (activeKey === 'back') {
      //   this.backForm.release_ids = release_ids;
      // }
      this.defaultActiveKey = activeKey;
    },
    submitNext() {
      this.$refs.nextForm.validate(valid => {
        if (valid) {
          this.loading.next = true;
          this.nextForm.release_ids = this.nextForm.release_ids === null ? [] : [this.nextForm.release_ids];
          workflowMove({ project_id: this.projectId, ...this.nextForm })
            .then(res => {
              this.nextForm.comment = '';
              this.nextForm.release_ids = null;
              this.nextForm.test_plans = [];
              this.loading.next = false;
              this.$message.success(res.message);
              this.$emit('onReload');
            })
            .catch(() => {
              this.loading.next = false;
            });
        }
      });
    },

    submitBack() {
      this.$refs.backForm.validate(valid => {
        if (valid) {
          const self = this;
          this.$confirm({
            title: '确认',
            content: `流程不通过后，将流转至「${self.options[self.backForm.to_step]}」，请确认`,
            okText: '确定',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
              self.$nextTick(() => {
                self.loading.back = true;
              });
            }
          });
        }
      });
    },

    submitComment() {
      this.$refs.commentForm.validate(valid => {
        if (valid) {
          this.loading.comment = true;
          workflowComment({ project_id: this.projectId, ...this.commentForm })
            .then(() => {
              this.commentForm.comment = '';
              this.loading.comment = false;
              this.$message.success('评论成功');
              this.$emit('onReload');
            })
            .catch(() => {
              this.loading.comment = false;
            });
        }
      });
    },
    onSubmit(operationType) {
      if (operationType === 'next') {
        this.submitNext();
      } else if (operationType === 'back') {
        this.submitBack();
      } else if (operationType === 'comment') {
        this.submitComment();
      }
    }
  }
};
</script>
<style lang="less">
.small-form-model {
  .ant-form-item {
    margin-bottom: 8px;
  }
}
.search-button {
  width: 100%;
}
.testplan-form-item {
  /deep/ .ant-form-item-control {
    line-height: unset;
  }

  .steps_table {
    padding-top: 3px;
    //margin-bottom: 1px;
    width: 960px;
    //box-sizing:border-box;
    display: inline-block;

    /deep/.ant-table-tbody > tr > td {
      padding: 2px;
      border-bottom: none;
    }
  }

  .plan_table {
    padding-top: 3px;
    //margin-bottom: 1px;
    width: 960px;
    //box-sizing:border-box;
    display: inline-block;
  }
}
</style>

<style lang="less" scoped>
.ant-card {
  margin: 16px 0;
}

/deep/.ant-card-body {
  padding: 16px;
}

/deep/.ant-tabs-nav .ant-tabs-tab {
  margin: -16px 32px 0 0;
}

.release-radio {
  display: block;
  height: 30px;
  line-height: 30px;
}

.workflow-alert-info {
  margin-bottom: 8px;
}

.submit-button {
  min-width: 100px;
}
</style>
